module.exports = __webpack_public_path__ + "img/decor-tire-type-320x108.428599ab.webp";